/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyListResponse {
    getFixupPrototypeFunction() { return PolicyListResponse.fixupPrototype; }

    static newInstance(model: Partial<PolicyListResponse>): PolicyListResponse {
        let obj = Object.assign(new PolicyListResponse(), model);
        PolicyListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyListResponse>): PolicyListResponse {
        if (!model) return null;
        return PolicyListResponse.newInstance(<PolicyListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyListResponse) {
        if (!obj) return;

        models.PolicyListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyListResponse): boolean {
        Object.setPrototypeOf(obj, PolicyListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.policies) {
            for (let val of this.policies) {
                models.PolicyDataList.fixupPrototype(val);
            }
        }
    }

    /**
     * Policy Metadata Info.
     */
    policies: Array<models.PolicyDataList>;

}
